import { IsDefined, Validate } from 'class-validator';
import * as uuid from 'uuid';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { QuotePaxValidator } from 'src/core/customValidator/quote-pax-validator';

export class QuotePaxGDPRDataService extends DataService<typeof Model.GDPR.Logic.ViewModels.QuotePaxGDPRItem, Model.GDPR.Logic.ViewModels.QuotePaxGDPRItem, QuotePaxGDPRItem> {
	protected map(entity: Model.GDPR.Logic.ViewModels.QuotePaxGDPRItem): QuotePaxGDPRItem {
		return new QuotePaxGDPRItemModel(entity);
	}

	static make(ctx?: any): QuotePaxGDPRDataService {
		return new QuotePaxGDPRDataService(ctx, ctx => ctx.QuotePaxsGDPR);
	}

	
}

export class QuotePaxGDPRItemModel extends EntityModel<Model.GDPR.Logic.ViewModels.QuotePaxGDPRItem, QuotePaxGDPRItem> implements QuotePaxGDPRItem {
	@property<QuotePaxGDPRItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: string;

	@property<QuotePaxGDPRItemModel>(o => o.entity.clientId, (o, value) => o.entity.clientId = value)
	public clientId?: number;

	@property<QuotePaxGDPRItemModel>(o => o.entity.quoteId, (o, value) => o.entity.quoteId = value)
	//@IsDefined({ message: 'quote is required' })
	public quoteId: number;

	@property<QuotePaxGDPRItemModel>(o => o.entity.quote, (o, value) => o.entity.quote = value)
	public quote: any;

	@property<QuotePaxGDPRItemModel>(o => o.entity.order, (o, value) => o.entity.order = value)
	public order: number;

	
	public get formalName(): string {
		return `${this.dynamicProperties['salutation'] || ''} ${this.dynamicProperties['foreName'] || ''} ${this.dynamicProperties['middleName'] || ''} ${this.dynamicProperties['surName'] || ''}`.trim();
	}

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	@Validate(QuotePaxValidator)
	public dynamicProperties: { [prop: string]: any };
}



// WEBPACK FOOTER //
// ./src/app/gdpr/clients/form/quote-pax-gdpr-form.data.ts